export enum ResearchTextElement {
  ContactUs = 'Contact Us',
}
